/**
 * Display name mappings for monitoring categories
 */
export const MONITORING_NAME_MAP: Record<string, string> = {
  digitalocean: 'Digital Ocean',
  ipv4: 'IPv4',
  ipv6: 'IPv6',
  github: 'GitHub',
  gitlab: 'GitLab',
  bitbucket: 'Bitbucket',
  amazon: 'AWS',
  azure: 'Azure',
  gcp: 'GCP',
  domain: 'Domains',
  subdomain: 'Subdomains',
  webapplication: 'Web Applications',
  ADDomain: 'AD Domains',
  ADUser: 'AD Users',
  ADComputer: 'AD Computers',
  ADGPO: 'AD GPOs',
  ADOU: 'AD OUs',
  external: 'External Internet',
  internal: 'Internal Intranet',
  cloud: 'Cloud',
  network: 'Network',
  code: 'Code',
  applications: 'Applications',
  internalNetwork: 'Internal Intranet',
  externalNetwork: 'Internet Perimeter',
  webseed: 'Web Coverage',
};

/**
 * Tooltip descriptions for monitoring categories
 */
export const MONITORING_TOOLTIP_MAP: Record<string, string> = {
  amazon: 'Assets directly imported from Amazon cloud infrastructure',
  azure: 'Assets directly imported from Microsoft Azure cloud infrastructure',
  gcp: 'Assets directly imported from Google Cloud Platform infrastructure',
  digitalocean:
    'Assets directly imported from DigitalOcean cloud infrastructure',
  ipv4: 'IPv4 addresses discovered through network scanning, excluding direct integration imports',
  ipv6: 'IPv6 addresses discovered through network scanning, excluding direct integration imports',
  domain:
    'Top-level domains discovered through DNS resolution, excluding direct integration imports',
  subdomain:
    'Subdomains discovered through DNS enumeration, excluding direct integration imports',
  github: 'Repositories and assets discovered through GitHub integration',
  gitlab: 'Repositories and assets discovered through GitLab integration',
  bitbucket: 'Repositories and assets discovered through BitBucket integration',
  ADDomain: 'AD Domains',
  ADUser: 'AD Users',
  ADComputer: 'AD Computers',
  ADGPO: 'AD GPOs',
  ADOU: 'AD OUs',
  webapplication: 'Web Applications',
  webseed: 'Web Coverage',
};
